import React, { createContext } from "react";

import useAuth from "../../hooks/useAuth.js";

const AuthContext = createContext();

const AuthProvider = ({ children }) => {
	const { loading, user, isAuth, handleLogin, handleLogout, handleValidate2FA, handleConfirmDevice, handleSetupMandatory2FA, handleVerifyMandatory2FA, handleForgotPassword, handleVerifyResetCode, handleResetPassword, socket } = useAuth();

	return (
		<AuthContext.Provider
			value={{ loading, user, isAuth, handleLogin, handleLogout, handleValidate2FA, handleConfirmDevice, handleSetupMandatory2FA, handleVerifyMandatory2FA, handleForgotPassword, handleVerifyResetCode, handleResetPassword, socket }}
		>
			{children}
		</AuthContext.Provider>
	);
};

export { AuthContext, AuthProvider };